<script lang="ts">
  interface Props {
    value?: string;
    label?: string;
    highlighted?: boolean;
    navIndex?: number;
    optionId?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let {
    value = '',
    label = '',
    highlighted = false,
    navIndex,
    optionId,
    onclick
  }: Props = $props();
</script>

{#if value}
  <button
    type="button"
    class="create-button"
    class:highlighted
    data-nav-index={navIndex}
    id={optionId}
    role="option"
    aria-selected={highlighted}
    {onclick}
  >
    <div class="text">{value}</div>
    {#if label}
      <div class="suffix">({label})</div>
    {/if}
  </button>
{/if}

<style>
  .create-button {
    text-align: left;
    display: flex;
    align-items: center;
    text-align: left;
    padding: 8px;
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    color: var(--grey-dark);
  }
  .create-button.highlighted {
    background-color: var(--light-blue);
  }
  .create-button .suffix {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: var(--grey-medium);
    margin-left: 4px;
  }
</style>
